export function isWediaryConfigured(value: string) {
  try {
    const url = new URL(value);
    const isWediaryHost =
      url.hostname === "mywediary.com" ||
      url.hostname.endsWith(".mywediary.com");
    const isMarketingHomepage =
      (url.hostname === "www.mywediary.com" ||
        url.hostname === "mywediary.com") &&
      (url.pathname === "/" || url.pathname === "");

    return url.protocol === "https:" && isWediaryHost && !isMarketingHomepage;
  } catch {
    return false;
  }
}
